import Inputmask from "inputmask";


export default function mask() {

    const maskEmail = document.querySelectorAll('[data-mask-email]');
    const maskName = document.querySelectorAll('[data-mask-name]');
    const maskNumber = document.querySelectorAll('[data-mask-number]');
    const maskCity = document.querySelectorAll('[data-mask-city]');

    if ( maskCity.length ) {
        for (let el of maskCity ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Zа-яА-ЯёЁ ]/g, '');
            });
        }
    }

    if ( maskEmail.length ) {
        for (let el of maskEmail ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Z0-9@._-]/g, '');
            });
        }
    }

    if ( maskName.length ) {
        for (let el of maskName ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Zа-яА-ЯёЁ0-9._ -]/g, '');
            });
        }
    }

    if (maskNumber.length) {
        for (let el of maskNumber) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^0-9]/g, '');
                if (this.value > +el.dataset.max) {
                    this.value = el.dataset.max;
                }
                if (this.value < +el.dataset.min) {
                    this.value = el.dataset.min;
                }
            });
        }
    }

    if(document.querySelectorAll('input[data-mask-tel]').length > 0) {
        let selector = document.querySelectorAll('input[data-mask-tel]');
        let im = new Inputmask('+7 (999) 999-99-99', {
        showMaskOnHover: false,
        });
        im.mask(selector);

        for (let el of selector ) {
            el.oninput = function() {
                if ( el.value.replace(/[()+_ -]/g,'').length < 11 ) {
                    el.setCustomValidity("Заполните телефон полностью");
                } else {
                    el.setCustomValidity("");
                }
            }
        }

    }

}